import React from 'react'

import PrivatePostsIndex from '@/pages/Posts/PrivatePostsIndex'

// /private_messages, /private_messages/:id and /private_messages/new are one
// full-bleed app view (see FULL_BLEED_ROUTES in App.jsx): no breadcrumbs or
// page title, the inbox header carries the "new message" button instead.
export default function PrivatePostsContainer () {
  return <PrivatePostsIndex />
}
